<div class="m-4">
  <h2 class="mb-4" i18n="@@outcome-approval.approve-all">Godkänn alla körorder</h2>
  <p class="mb-5" i18n="@@outcome-approval.confirm">Detta godkänner alla körorder på denna beställning som inte kräver kontroll. Vill du gå vidare?</p>

  <div class="d-flex">
    <button class="btn btn-outline-primary btn-min-width ms-auto me-2" id="dismissBtn" type="button" (click)="activeModal.dismiss()" [disabled]="buttonsDisabled" i18n="@@outcome-approval.no">Nej</button>
    <button class="btn btn-primary btn-min-width" id="approveBtn" type="button" (click)="approve()" [disabled]="buttonsDisabled" i18n="@@outcome-approval.yes">Ja</button>
  </div>
</div>
